export const koTranslations = {
    "home": "홈",
    "community": "커뮤니티",
    "writing": "글쓰기",
    "store": "스토어",
    "my_channel": "마이채널",
    "title": "타이틀",
    "language_settings": "언어 설정",
    "display_language": "표시 언어",
    "select_language": "언어 선택",
    "korean": "한국어",
    "english": "영어",
    "japanese": "일본어",
    "shipping_info": "배송지 정보",
    "confirm_consent": "동의합니다",
    "disagree_consent": "미동의",
    "enter_shipping": "배송 정보 입력",
    "check_shipping": "배송 조회",
    "shipping_preparing": "배송이 준비중입니다.",
    "shipping_ready": "배송준비",
    "refund_completed": "환불 완료",
    "rewards_info": "경품 관리",
    "personal_info_consent": "경품 수령을 위한 개인정보 수집 이용 동의",
    "collection_purpose": "수집 및 이용 목적",
    "delivery_purpose": "이벤트 당첨 경품 지급 및 배송",
    "retention_period": "보유기간",
    "retention_duration": "경품 지급 완료 후 최대 3개월",
    "collection_items": "개인정보 수집 항목",
    "collection_details": "이름, 휴대폰 번호, 수령지 주소",
    "agree": "동의",
    "disagree": "미동의",
    "next": "다음",
    "complete": "완료",
    "change_address": "배송지 변경",
    "delivery_guide": "상품 수령 안내",
    "guide_1": "경품은 배송지 입력 후 2주 이내 수령 가능합니다.",
    "guide_2": "배송지 오입력 등에 대한 과실은 당첨자 본인에게 있습니다.",
    "guide_3_prefix": "경품 발송 관련 문의는",
    "guide_3_suffix": "를 이용해주시기 바랍니다.",
    "account_settings": "계정 및 설정",
    "account_settings_title": "계정 및 설정",
    "notifications": "알림",
    "my_profile": "프로필",
    "logout": "로그아웃",
    "login_required": "로그인이 필요한 기능입니다.",
    "back_to_login": "로그인 화면으로 이동하시겠어요?",
    "later": "나중에",
    "yes": "예",
    "attendance": "출석체크",
    "mission_participation": "챌린지",
    "roulette": "룰렛",
    "submit_work": "작품투고",
    "free_trial": "무료체험",
    "qualification_test": "자격시험",
    "post_news": "조커소식",
    "contact": "오시는길",
    "membership": "조커 멤버십",
    "followers": "팔로우",
    "following": "팔로잉",
    "edit_profile": "내 정보 수정",
    "invite_friends": "친구 초대",
    "level_suffix": "님의 등급은",
    "daily_mission_title": "매일 활동 미션을 달성해보세요!",
    "app_checkin": "앱 출석체크",
    "upload_post": "신규 게시글 업로드",
    "follow_friend": "친구 팔로우",
    "posts": "게시글",
    "bookmarks": "북마크",
    "likes": "좋아요",
    "comments": "댓글",
    "post_type": "게시글",
    "news_type": "소식지",
    "product_type": "조커 마켓",
    "challenge_type": "챌린지",
    "all_type": "전체",
    "just_now": "방금 전",
    "minute_ago": "1분 전",
    "minutes_ago": "분 전",
    "hour_ago": "1시간 전",
    "hours_ago": "시간 전",
    "day_ago": "1일 전",
    "days_ago": "일 전",
    "week_ago": "1주 전",
    "weeks_ago": "주 전",
    "year_ago": "1년 전",
    "years_ago": "년 전",
    "remaining_points": "등급 까지 남은 포인트 :",
    "level_text": "등급",
    "grade": "등급",
    "member_benefits": "회원 혜택",
    "point_history": "포인트 내역",
    "membership_info": "멤버십 안내",
    "membership_category": "구분",
    "membership_condition": "달성 조건",
    "membership_level_up_points": "등급 달성 시\n축하 포인트",
    "membership_post_points": "글 작성 시\n추가 지급",
    "membership_discount_rate": "상품 할인",
    "membership_like_reward": "공감",
    "membership_comment_reward": "덧글",
    "membership_guest_condition": "가입 시\n최초 등급",
    "accumulated_points": "누적 포인트",
    "from": "부터",
    "point_earning_methods": "포인트 적립 방법",
    "payment": "결제",
    "payment_shipping_request": "결제/배송신청",
    "shipping_address_management": "배송지 관리",
    "qualification_exam_management": "자격 시험 관리",
    "notification_settings": "알림 설정",
    "push_notifications": "푸시 알림 수신",
    "event_ad_recommendation_notifications": "이벤트/광고 및 추천 알림 수신",
    "announcements": "공지사항",
    "faq": "FAQ",
    "customer_support": "고객문의",
    "version_information": "버전 정보",
    "app_information_and_policies": "앱 정보 및 약관/정책",
    "login": "로그인",
    "payment_shipping_history": "결제/배송 내역",
    "payment_detail": "결제 내역 상세",
    "prize_registration_complete": "경품 등록 완료",
    "shipping_in_progress": "배송중",
    "enter_shipping_info": "배송 정보 입력",
    "roulette_reward": "룰렛 보상",
    "no_rewards_history": "경품 내역이 없습니다.",
    "shipping_scheduled": "배송 예정",
    "shipping_complete": "배송 완료",
    "cancel_return": "취소·반품",
    "exchange_application": "교환·반품 신청",
    "link_not_exist": "링크가 존재하지 않습니다",
    "confirm": "확인",
    "product_purchase": "상품 구매",
    "point_exchange": "포인트 교환",
    "point_reason": "이유",
    "no_payment_shipping_history": "결제/배송 신청 내역이 없어요.",
    "address_name": "배송지 이름",
    "address_name_placeholder": "배송지 이름을 입력해 주세요.",
    "recipient_name": "수령인 이름",
    "recipient_name_placeholder": "수령인 이름을 입력해 주세요.",
    "phone_number": "휴대폰번호",
    "phone_number_placeholder": "전화번호를 입력해 주세요.",
    "address": "주소",
    "address_search_placeholder": "주소 찾기",
    "address_search_button": "주소 찾기",
    "address_detail_placeholder": "상세 주소",
    "address_memo": "배송지 메모",
    "address_memo_placeholder": "택배 보관장소, 공동 현관 출입 비밀번호 등",
    "save": "저장",
    "address_name_error": "배송지 이름을 입력해 주세요.",
    "address_name_max_error": "최대 10글자까지만 입력 가능합니다.",
    "recipient_name_error": "수령인 이름을 입력해 주세요.",
    "phone_number_error": "전화번호는 10자리에서 11자리여야 합니다.",
    "address_error": "주소를 입력해 주세요.",
    "address_max_error": "주소는 최대 30글자까지만 입력 가능합니다.",
    "address_memo_max_error": "배송지 메모는 최대 20글자까지만 입력 가능합니다.",
    "select": "선택",
    "delete": "삭제",
    "edit": "수정",
    "no": "아니요",
    "company": "회사",
    "recipient": "수령인",
    "delete_address_confirm": "배송지를 삭제할까요?",
    "delete_address_description": "삭제된배송지는 복구할 수 없으며,<br />신규로등록하셔야 합니다.",
    "default_address_set": "기본 배송지로 설정되었습니다.",
    "default_address_error": "기본 배송지 설정에 실패했습니다.",
    "address_deleted": "주소가 삭제되었습니다.",
    "no_registered_address": "등록된 배송지가 없어요.",
    "add_address_prompt": "배송지를 추가해 주세요!",
    "add_address": "배송지 추가",
    "max_address_limit": "배송지는 최대 5개까지 등록 가능 합니다.",
    "delete_address_to_add": "기존배송지 삭제 후 새로운 배송지를 추가해 주세요!",
    "change_status": "상태 변경",
    "report": "신고",
    "make_private": "비공개로 전환",
    "make_public": "공개로 전환",
    "hide_post": "게시물 숨기기",
    "block_user": "차단하기",
    "cancel": "취소",
    "post_delete_confirm": "삭제한 게시물은 복구할 수 없습니다.<br />정말 삭제하시겠습니까?",
    "no_posts": "아직 등록된 게시물이 없습니다.<br />첫 번째 게시물을 올려보세요.",
    "no_challenges": "진행중인 챌린지가 없습니다.<br /> 더 재밌는 챌린지를 준비중이니 조금만 기다려 주세요.",
    "error_occurred": "에러가 발생했습니다 .. 다시 시도 해주세요",
    "no_bookmarks": "아직 저장된 북마크가 없습니다.<br />간직하고 싶은 게시물을 북마크해 보세요.",
    "no_likes": "아직 좋아요한 게시물이 없습니다.<br />마음에 드는 게시물에 좋아요를 눌러보세요.",
    "no_comments": "아직 작성한 댓글이 없습니다.<br />다른 친구들과 댓글을 통해 소통해 보세요.",
    "view_all_channel": "내 채널 모두 보기",
    "coming_soon_title": "서비스를 준비 중입니다.",
    "coming_soon_description": "해당 기능은 현재 최종 개발 단계에 있으며,\n곧 서비스에 반영될 예정입니다.\n기대해주세요!",
    "store_title": "스토어",
    "sort_method": "정렬 방식",
    "sort_default": "기본",
    "sort_popularity": "인기도순",
    "sort_latest": "최신 등록순",
    "sort_price_asc": "낮은 가격순",
    "sort_price_desc": "높은 가격순",
    "sort_discount": "할인율순",
    "sort_sales": "판매 많은순",
    "sort_reviews": "리뷰 많은순",
    "sort_rating": "평점 높은순",
    "no_products": "상품이 없습니다.",
    "category": "카테고리",
    "shipping_fee": "배송비",
    "coupon": "쿠폰",
    "coupon_available_count": "사용 가능 {count}장",
    "coupon_register_or_none": "쿠폰 등록·선택",
    "point_use": "포인트 사용",
    "point_use_all": "전액 사용",
    "point_use_hint": "보유 {balance}P · 상품 금액의 30%({cap}P)까지 사용 가능",
    "chk_point_hint_coupon_min_cash": "쿠폰을 쓰면 결제 금액이 최소 100원이어야 해서 이 주문에는 포인트를 함께 쓸 수 없어요.",
    "chk_point_hint_no_balance": "보유한 포인트가 없어요.",
    "chk_point_hint_unavailable": "이 주문에는 포인트를 쓸 수 없어요.",
    "chk_coupon_register_link": "+ 쿠폰 등록",
    "chk_coupon_applied_of": "사용 가능 {total}장 중 1장 적용",
    "chk_coupon_cancel": "쿠폰 적용 취소",
    "coupon_discount": "쿠폰 할인",
    "point_discount": "포인트 할인",
    "total_payment_amount": "최종 결제금액",
    "book_page_locked": "구매 후 열람 가능한 페이지입니다",
    "book_buy_now": "구매하기",
    "book_page": "페이지",
    "book_prev_page": "이전 페이지",
    "book_next_page": "다음 페이지",
    "book_zoom_out": "축소",
    "book_zoom_in": "확대",
    "book_not_found": "상품을 찾을 수 없습니다.",
    "book_load_error": "e-book 정보를 불러오지 못했습니다.",
    "book_viewer_title": "미리보기",
    "book_no_pages": "열람 가능한 페이지가 없습니다.",
    "coupon_menu_title": "쿠폰등록 및 보유쿠폰",
    "cpn_register_title": "지류쿠폰 번호 등록",
    "cpn_code_placeholder": "8자리 쿠폰 번호",
    "cpn_code_hint": "쿠폰 뒷면의 8자리 번호를 입력해 주세요.",
    "cpn_register_success": "{amount}원 쿠폰이 등록되었어요. 결제할 때 사용할 수 있어요.",
    "cpn_tab_available": "사용 가능",
    "cpn_tab_history": "사용 완료·만료",
    "cpn_sort_available": "만료일 가까운 순",
    "cpn_sort_history": "최근 순",
    "cpn_badge_used": "사용 완료",
    "cpn_badge_expired": "기간 만료",
    "cpn_badge_voided": "사용 불가",
    "cpn_partner_line": "{partner} 제휴",
    "cpn_min_order": "{amount}원 이상 결제 시 사용",
    "cpn_all_products": "전 상품 사용 가능",
    "cpn_until": "~ {date} 까지",
    "cpn_used_line": "{date} 사용",
    "cpn_used_line_order": "{date} 사용 · 주문번호 {orderId}",
    "cpn_expired_line": "{date} 만료 · 미사용",
    "cpn_history_notice": "주문을 전체 취소하면 유효기간이 남은 쿠폰은 사용 가능 탭으로 돌아가요.",
    "my_ebooks_page_title": "구매한 e-book",
    "coupon_select_title": "쿠폰 선택",
    "coupon_none_applicable": "사용 가능한 쿠폰이 없습니다.",
    "coupon_apply_amount": "-{amount}원",
    "coupon_expires_until": "{date}까지",
    "coupon_selected": "선택됨",
    "coupon_dont_use": "쿠폰 안 쓰기",
    "coupon_go_register": "쿠폰 등록하러 가기",
    "cpk_order_info": "주문 금액 {order}원 · 한 번 결제에 쿠폰 1장만 쓸 수 있어요",
    "cpk_none": "쿠폰 적용 안 함",
    "cpk_banner": "쿠폰 금액이 주문 금액보다 크면 남은 금액은 사라져요.",
    "cpk_apply": "{amount}원 할인 적용하기",
    "cpk_apply_none": "쿠폰 없이 결제하기",
    "cpk_register": "+ 쿠폰 등록",
    "cpk_all_products": "전 상품 사용 가능",
    "cpk_close": "닫기",
    "cpk_min_order": "{amount}원 이상 결제 시 사용 가능",
    "cpk_expires": "~ {date}",
    "chk_product_amount": "상품 금액",
    "chk_payment_amount": "결제 금액",
    "chk_title": "결제하기",
    "chk_order_product": "주문 상품",
    "chk_ebook_label": "e-book",
    "chk_pay_suffix": "결제하기",
    "gate_banner_text": "새 버전이 나왔어요",
    "gate_banner_update": "업데이트",
    "gate_banner_close": "닫기",
    "gate_block_title": "앱 업데이트가 필요해요",
    "gate_block_body": "지금 쓰는 앱 버전은 더 이상 지원되지 않아요.\n스토어에서 최신 버전으로 업데이트한 뒤 다시 열어 주세요.",
    "gate_block_note": "계정·포인트·작품은 그대로예요.\n마이룸 같은 새 기능은 최신 앱에서만 쓸 수 있어요.",
    "gate_block_button": "업데이트하러 가기",
    "gate_block_no_store": "앱스토어에서 ‘조이쌤 커넥트’를 검색해 업데이트해 주세요.",
    "gate_block_help": "업데이트가 안 되면 부모님께 도움을 요청해 주세요.\n기기 저장공간이 부족하거나 기기가 너무 오래된 경우에도 업데이트가 안 될 수 있어요.",
    "coupon_register_success": "{amount}원 쿠폰이 등록되었습니다.",
    "coupon_register_failed": "쿠폰을 등록하지 못했습니다. 잠시 후 다시 시도해 주세요.",
    "coupon_locked_notice": "약 {minutes}분 뒤에 다시 시도할 수 있습니다.",
    "coupon_status_used": "사용완료",
    "coupon_status_expired": "기간만료",
    "coupon_status_voided": "사용불가",
    "coupon_status_available": "사용가능",
    "coupon_min_order": "{amount}원 이상 구매 시 사용 가능",
    "coupon_none_usable_now": "지금 쓸 수 있는 쿠폰이 없어요",
    "coupon_register_title": "쿠폰 등록",
    "coupon_code_label": "쿠폰 번호",
    "coupon_code_placeholder": "쿠폰 번호 8자리 (예: J1234567)",
    "coupon_register_button": "등록",
    "coupon_tab_available": "사용 가능",
    "coupon_tab_history": "사용완료·만료",
    "coupon_load_failed": "쿠폰 목록을 불러오지 못했습니다.",
    "coupon_empty_available": "사용 가능한 쿠폰이 없습니다. 지류쿠폰 번호를 등록해 보세요.",
    "coupon_empty_history": "사용완료·만료된 쿠폰이 없습니다.",
    "load_more": "더 보기",
    "my_ebooks_total": "총",
    "my_ebooks_count_suffix": "권",
    "my_ebooks_sort_label": "정렬",
    "my_ebooks_sort_recent_purchase": "최근 구매순",
    "my_ebooks_sort_recent_read": "최근 읽은 순",
    "my_ebooks_sort_title": "제목순",
    "my_ebooks_load_error": "e-book 목록을 불러오지 못했습니다.",
    "my_ebooks_go_store": "스토어로 가기",
    "my_ebooks_purchased_at": "구매일",
    "myebooks_completed": "완독",
    "myebooks_unread": "아직 읽지 않았어요",
    "myebooks_purchased_suffix": "구매",
    "myebooks_order_no": "주문번호",
    "myebooks_resume": "이어 읽기",
    "myebooks_start": "읽기 시작하기",
    "myebooks_empty_title": "아직 구매한 e-book이 없어요",
    "myebooks_empty_desc": "e-book을 구매하면 여기에서\n언제든 다시 꺼내 읽을 수 있어요.",
    "myebooks_browse": "e-book 둘러보기",
    "ebook_menu_title": "구매한 전자책",
    "my_benefits_title": "보유 자산",
    "ebook_refund_consent": "e-book은 열람을 시작하면 환불이 어려워요. 이 내용을 확인했습니다.",
    "read_ebook_now": "바로 보기",
    "my_ebooks_title": "내가 구매한 e-book",
    "my_ebooks_empty": "구매한 e-book이 없습니다.",
    "my_ebooks_pages_suffix": "쪽",
    "my_ebooks_view_all": "전체 보기",
    "my_ebooks_collapse": "접기",
    "ebook_no_shipping": "e-book · 배송 없음",
    "product_not_found": "상품을 찾을 수 없습니다.",
    "currency_won": "원",
    "free_shipping_condition": "단, {threshold}{currency} 이상 구매 시 무료",
    "free_shipping_remaining": "{amount}{currency} 더 담으면 무료배송",
    "free_shipping_applied": "무료배송 적용됨",
    "currency_points": "P",
    "product_info": "상품 정보",
    "product_details": "상세정보",
    "product_description": "상품 설명",
    "reviews": "별점",
    "no_faq": "FAQ가 없습니다.",
    "faq_loading_error": "FAQs를 불러올 수 없습니다.",
    "no_reviews": "아직 등록된 평가가 없습니다.",
    "product_name": "상품명",
    "price": "가격",
    "purchase": "구매하기",
    "quantity_select": "수량 선택",
    "total_amount": "총 금액",
    "payment_in_progress": "결제 진행 중...",
    "payment_method": "결제 수단",
    "order_product": "주문상품",
    "order_checkout": "주문/결제",
    "add_address_new": "배송지 추가+",
    "membership_discount": "멤버십 할인",
    "quantity_error": "주문하신 수량이 이 제품의 최대 수량에 도달했습니다.",
    "cart_max_stock_reached": "{name} 상품은 이미 장바구니에 최대 수량이 담겨 있습니다.",
    "cart_stock_exceeded": "{name} - 장바구니에 추가로 담을 수 있는 수량은 최대 {n}개입니다.",
    "membership_discount_info": "*조이쌤 멤버십 등급별로 할인율 차등 적용됩니다.",
    "total_order_amount": "총 주문금액",
    "delivery_address": "배송지 정보",
    "prize_guide": "경품 수령 안내",
    "customer_service": "고객센터",
    "quantity_unit": "개",
    "select_delivery_address": "배송지 선택",
    "submission_complete": "제출완료",
    "payment_failed": "결제 실패",
    "payment_error_message": "결제가정상적으로 이루어지지 않았습니다.",
    "retry_instruction": "확인후 다시 시도해 주세요.",
    "go_to_home": "홈으로 이동",
    "challenge_thanks": "챌린지에 참가해주셔서 감사합니다.",
    "challenge_wish": "좋은 결과가 있기를 응원하겠습니다.",
    "product_label": "상품",
    "and_others_count": "외 {count}건",
    "order_completed_message": "주문이\n완료되었습니다.\n\n감사합니다.",
    "post_tag": "게시물 태그",
    "user_nickname": "유저 닉네임",
    "product_category": "상품",
    "search_keyword_placeholder": "검색어 입력하기...",
    "recommended_keywords": "추천 검색어",
    "no_recommended_keywords": "추천 검색어가 없습니다",
    "search_category": "검색 카테고리",
    "no_search_results": "검색 결과가 없습니다.",
    "english_name_error": "영문임은 두글자 이상 입력해 주세요.",
    "korean_name_error": "한글임은 두글자 이상 입력해 주세요.",
    "age_error": "나이를 숫자로 입력해 주세요.",
    "experience_error": "경력을 숫자로 입력해 주세요.",
    "email_placeholder": "이메일 주소를 입력해 주세요.",
    "korean_name": "이름(한글)",
    "korean_name_placeholder": "이름(한글)을 입력해 주세요.",
    "english_name": "이름(영문)",
    "english_name_placeholder": "이름(영문)을 입력해 주세요.",
    "birth_date": "생년월일",
    "birth_date_placeholder": "생년월일을 입력해 주세요.",
    "age_placeholder": "나이를 숫자로 입력해 주세요.",
    "origami_experience": "종이접기 경력",
    "numeric_only": "숫자만 입력해 주세요.",
    "phone_placeholder": "전화번호를 입력해 주세요.",
    "gender": "성별",
    "male": "남자",
    "female": "여자",
    "check_invitation_code": "초대코드를 확인해주세요",
    "points_earned": "포인트가 적립되었습니다.",
    "invitation_code_instruction": "친구에게받은 초대코드를<br />입력해 주세요.",
    "invitation_code_placeholder": "초대코드 입력",
    "register": "등록하기",
    "email": "이메일",
    "copied_to_clipboard": "클립보드에 복사되었습니다.",
    "my_invitation_code": "내 초대코드",
    "invite_friends_benefit": "친구가 조이쌤을 설치하면<br />친구도, 나도 포인트를 받아요.",
    "invitation_code_copy_guide": "내 초대코드 영역을 선택하면 클립보드에 복사됩니다.",
    "invitation_code_limit_guide": "초대코드를 통한 포인트 적립은 최대 50번까지 가능합니다. 50번을 초과하는 경우, 친구에게만 포인트가 적립됩니다.",
    "invite_friends_share_button": "공유하기",
    "invite_friends_share_message": "조이쌤에서 함께 놀아요! 가입한 뒤 초대코드 {code} 를 입력하면 친구도 나도 포인트를 받아요.",
    "age": "나이",
    "country": "국가",
    "submission_not_completed": "출품이 완료되지 않았습니다.",
    "pay_submission_fee": "네, 납부할게요!",
    "feature_under_development": "이 기능은 열심히 개발중입니다.<br />멋진 업데이트로 찾아뵙겠습니다!",
    "must_pay_before_submit": "새 신청서를 제출하기 전에 비용을 지불해야 합니다.",
    "no_active_submission_challenge": "진행중인 작품투고 챌린지가 없습니다.",
    "challenge_fee_notice_part1": "본 챌린지는 참가비",
    "challenge_fee_notice_part2": "원을 납부해야",
    "challenge_fee_notice_part3": "출품이 완료됩니다.\n\n참가하시겠습니까?",
    "featured_posts": "인기 게시물",
    "latest_posts": "최신 게시물",
    "view_more": "더보기",
    "joker_market": "조커 마켓",
    "joker_market_desc": "내 작품이나 굿즈, 용품, 책을 거래해요",
    "board_desc": "내 작품을 자랑해요",
    "no_related_questions": "아직 관련 질문이 없습니다.",
    "curious_title": "이런게 궁금해요",
    "no_faqs_registered": "등록된 FAQ가 없습니다.",
    "board": "게시판",
    "newsletter": "소식지",
    "point_exchange_shop": "포인트 교환소",
    "footer_terms_of_service": "서비스 이용 약관",
    "footer_company": "상호: (주)조이쌤",
    "footer_ceo": "대표자명: 정규일",
    "footer_address": "주소: 서울특별시 용산구 원효로90길 11, 주거동 비203 용산비지니스센터 22호",
    "footer_business_reg": "사업자등록번호: 503-87-03074",
    "footer_phone": "전화번호: 070-4621-3262",
    "footer_mail_order_reg": "통신판매업 신고번호: 2026-서울용산-0302",
    "footer_email": "이메일: joysam6061@gmail.com",
    "footer_copyright": "© 조이쌤 커넥트. All rights reserved.",
    "dm_title": "님의 DM",
    "no_conversations": "대화가 없습니다",
    "image_text": "[이미지]",
    "deleted_message": "[삭제된 메시지]",
    "user": "사용자",
    "no_notifications": "새로운 알림이 없어요.",
    "attendance_check_in": "출석체크",
    "attendance_already_participated": "오늘은 이미 출석체크 미션에 참가하셨습니다. 내일 또 방문해주세요!",
    "attendance_empty": "아쉽게도 진행중인 출석체크 미션이 없습니다.",
    "congratulations": "축하합니다!",
    "gift_reward_won": "리워드에 당첨되셨어요!",
    "point_reward_won": "포인트에 당첨되셨어요!",
    "attendance_enter_shipping": "리워드를 받아볼 주소를 입력하러 갈까요?",
    "later_input": "나중에 입력",
    "attendance_confirm": "확인",
    "go_back": "이전 페이지로 이동",
    "connections_search_placeholder": "닉네임 입력하기...",
    "connections_followers": "팔로워",
    "connections_following": "팔로잉",
    "connections_recommendations": "추천",
    "connections_no_search_results": "검색 결과가 없어요!",
    "connections_no_followers": "나를 팔로우한 유저가 없어요.",
    "connections_make_friends": "친구를 사귀어 보세요!",
    "connections_no_following": "팔로우한 유저가 없어요.",
    "connections_no_users_found": "사용자를 찾을 수 없어요.",
    "connections_refresh_recommendations": "추천 새로받기",
    "follow": "팔로우",
    "unfollow": "언팔로우 하기",
    "button_following": "팔로잉",
    "follow_cancelled": "팔로우 취소됨",
    "follow_started": "팔로우 시작됨",
    "follow_status_change_failed": "팔로우 상태 변경에 실패했습니다.",
    "bonus_points_earned": "포인트가 적립되었습니다.",
    "edited_label": "(수정)",
    "leader_label": "리더",
    "event_roulette": "룰렛",
    "event_attendance": "매일 출석체크",
    "event_free_trial": "무료체험",
    "event_qualification_test": "자격시험",
    "shipping_address_info": "배송지 정보",
    "select_address": "배송지 선택",
    "registering_address": "배송지 등록 중...",
    "roulette_no_missions": "아쉽게도 진행중인 룰렛미션이 없습니다.",
    "roulette_unlucky": "꽝이라니 아쉬워요!<br/>다음에 다시 도전해 주세요!",
    "roulette_lucky_points": "축하합니다! {points} 포인트에 당첨되셨어요!",
    "roulette_lucky_gift": "축하합니다! {productName}에 당첨되셨어요! {productName} 리워드를 받아볼 주소를 입력하러 갈까요?",
    "roulette_enter_shipping": "배송지 입력",
    "roulette_confirm": "확인",
    "roulette_share_title": "공유하고 추가 기회 획득!",
    "roulette_share_description": "SNS에 공유하면 하루 최대 {maxShares}회까지 추가 룰렛 기회를 드립니다.<br/>(현재 공유 횟수: {sharesUsed}/{maxShares}회)",
    "roulette_share_accept": "공유하기",
    "roulette_share_cancel": "닫기",
    "roulette_share_success": "공유가 완료되어 추가 기회가 지급되었습니다!",
    "roulette_share_toast_success": "링크가 복사되었습니다. 추가 룰렛 기회가 1회 지급되었습니다!",
    "level_up_congratulations": "축하합니다! {levelName}을 달성하셨습니다! {points} 포인트가 적립되었습니다!",
    "roulette_congratulations": "축하합니다!",
    "roulette_gift_won": "에 당첨되셨어요!",
    "roulette_gift_reward_address": "리워드를 받아볼 주소를",
    "roulette_gift_question": "입력하러 갈까요?",
    "challenge_event_name": "챌린지/이벤트명",
    "roulette_won": "당첨",
    "personal_info_collection_details": "개인정보 수집 및 이용 내역",
    "company_processing_notice": "당사는 이벤트 진행 및 경품 지급을 위하여 아래와 같이 업무를 처리합니다.",
    "contractor_label": "수탁사",
    "contractor_name": "한진택배",
    "contractor_purpose": "경품 발송",
    "refuse_collection_notice": "위의 개인정보 수집 이용에 대한 동의를 거부할 권리가 있습니다. 그러나, 동의를 거부할 경우 이벤트 진행 및 서비스 제공 대상에서 제외됨을 알려드립니다.",
    "shipping_success_message": "감사합니다!<br />고객님의 선물이 준비 중이며 곧 발송될 예정입니다<br />주문 정보를 계속 확인해 주세요.",
    "withdrawal_title": "회원탈퇴",
    "withdrawal_confirm_question": "정말로 탈퇴하시겠습니까?",
    "withdrawal_content_info": "회원님께서 가지고 계신 콘텐츠와 포인트는<br />다음과 같습니다.",
    "my_posts": "내 게시글",
    "my_points": "내 포인트",
    "scheduled_shipping": "배송 예정",
    "withdrawal_warning_1": "탈퇴하시면 작성한 게시글과 가지고 계신 포인트가 모두 사라집니다.",
    "withdrawal_warning_2": "탈퇴하시더라도 배송 예정인 상품은 배송이 진행되지만 내역은 확인하기 어려우실 수 있습니다.",
    "withdrawal_button": "탈퇴하기",
    "withdrawal_cancel": "취소",
    "comment_actions_post": "댓글",
    "comment_delete": "삭제",
    "comment_cancel": "취소",
    "comment_banned": "이 댓글은 금지되었습니다.",
    "comment_deleted_by_admin": "관리자에 의해 삭제된 댓글입니다",
    "comment_reported": "신고한 댓글입니다.",
    "comment_deleted_by_owner": "소유자가 댓글을 삭제했습니다.",
    "comment_view_more": "댓글 {count}개 더보기",
    "comment_hide": "댓글 숨기기",
    "comment_placeholder": "댓글 달기...",
    "comment_max_images": "최대 5개까지만 업로드가 가능합니다.",
    "comment_deleted": "게시물을 삭제했어요.",
    "comment_created": "댓글을 작성했어요.",
    "comment_reported_submitted": "신고가 접수되었습니다.",
    "comment_hidden": "댓글이 숨겨졌습니다.",
    "comment_hide_error": "댓글 숨기기 중 오류가 발생했습니다.",
    "post_made_private": "비공개 게시글로 전환되었습니다.",
    "post_made_public": "공개 게시글로 전환되었습니다.",
    "user_blocked_success": "차단이 완료되었습니다. 이제 이 사용자의 게시글을 더 이상 보지 않게 됩니다.",
    "user_block_error": "사용자 차단 중 오류가 발생했습니다.",
    "post_detail_sort": "정렬",
    "challenge_ended": "챌린지 종료",
    "time_remaining": "남은 시간",
    "today_news": "오늘의 조커 소식",
    "year_unit": "년",
    "month_unit": "월",
    "day_unit": "일",
    "day_sun": "일",
    "day_mon": "월",
    "day_tue": "화",
    "day_wed": "수",
    "day_thu": "목",
    "day_fri": "금",
    "day_sat": "토",
    "view_post_detail": "게시물 자세히 보기",
    "join_mission": "주간미션 참여하기",
    "check_winner": "당첨자 확인하기",
    "participation_complete": "참여 완료",
    "post_reported_success": "해당 게시글을 성공적으로 신고하였습니다.",
    "product_selling": "판매 중",
    "product_reserved": "예약 중",
    "product_sold": "판매 완료",
    "status_changed": "상태가",
    "status_changed_suffix": "(으)로 변경되었습니다.",
    "status_change_failed": "상태 변경에 실패했습니다",
    "no_comments_yet": "아직 작성된 댓글이 없어요",
    "be_first_commenter": "첫 번째 댓글을 작성해주세요.",
    "submit_additional": "추가 제출하기",
    "submit_payment": "납부하기",
    "yes_payment": "네, 납부할게요!",
    "challenge_fee_submission_part1": "본 챌린지는 참가비",
    "challenge_fee_submission_part2": "을 납부해야",
    "challenge_fee_submission_part3": "출품이 완료됩니다.",
    "challenge_fee_submission_part4": "참가하시겠습니까?",
    "submission_not_completed_button": "출품이 완료되지 않았습니다.",
    "challenge_fee_part1": "본 챌린지는",
    "challenge_fee_part2": "원 참여 금액이",
    "challenge_fee_part3": "발생하는 유료참여 챌린지 입니다.",
    "yes_proceed": "네, 진행할게요!",
    "no_button": "아니오",
    "challenge_fee_refund_part1": "결제 후 미션에 참여하지 않는 경우,",
    "challenge_fee_refund_part2": "미션 참여 기간 종료 후 일괄환불",
    "challenge_fee_refund_part3": "이 진행됩니다.",
    "challenge_fee_refund_part4": "계속 진행하시겠습니까?",
    "draft_continue_confirm": "임시저장한 출품작 정보를 계속 작성하시겠습니까?",
    "draft_new_info": "새로운 출품작 정보를 작성하는 경우,",
    "draft_info_disappear": "임시저장한 내용은 사라집니다.",
    "draft_saved_at": "에 저장한.",
    "draft_has_content": "출품 내용이 있습니다.",
    "draft_create_new": "새로 작성하기",
    "draft_continue_writing": "계속 작성하기",
    "multi_submit_challenge_info": "추가 제출이 가능한 챌린지이며,",
    "submit_count_unlimited": "출품개수와 상관없이 참여할 수 있습니다.",
    "challenge_participate_confirm": "참가하시겠습니까?",
    "already_participated": "이미 참가한 챌린지입니다.",
    "yes_submit_additional": "네, 추가 출품할게요!",
    "something_went_wrong": "무언가 잘못되었습니다",
    "make_payment": "결제하기",
    "payment_info": "결제 정보",
    "payment_method_selection": "결제 방법",
    "agree_payment_terms": "결제및 이용약관에 동의합니다",
    "payment_cancel_notice": "결제 취소는 결제일로부터 7일 이내에만 할 수 있습니다.",
    "minor_consent_notice_part1": "미성년자의 경우 결제 시 법정대리인의 동의가 필요하며,",
    "minor_consent_notice_part2": "이에 따라 법정대리인의 동의를 받았음을 확인합니다.",
    "electronic_payment_terms": "전자금융거래이용약관",
    "chapter1_general": "제 1장:총칙",
    "article1_purpose": "제 1조(목적)이약관은 본 서비스를 이용하는 사용자와 서비스 제공자 간의 권리, 의무,책임사항및 기타 필요한 사항을 규정하는 것을 목적으로 합니다.",
    "article2_definitions": "제 2조(용어의정의)",
    "article2_service": "\"서비스\"란회사가 제공하는 각종 서비스를 의미합니다.",
    "article2_user": "\"이용자\"란본 약관에 동의하고 회사가 제공하는 서비스 를 이용하는 자를 말합니다.",
    "chapter2_service_contract": "제 2장:서비스 이용 계약",
    "chapter2_content": "1.서비스이용 계약은 이용자가 약관에 동의하고 회사가 정한 가입 양식을 작성하여 제출함으로써 성립합니다. 이용자는서비스 신청 시 모든 제공된 정보가 실제 정보 이며 정확하게 제공되어야 합니다.",
    "chapter3_service_use_management": "제 3장:서비스이용 및 관리",
    "article4_provision_change": "제 4조(서비스의제공 및 변경)",
    "article4_content1": "회사는이용자에게 서비스를 제공할 수 있으며, 제공는 서비스의 내용은 회사의 정책에 따릅니다.",
    "article4_content2": "회사는운영상 또는 기술상의 필요에 따라 서비스의 내용을 변경할 수 있습니다.",
    "article5_interruption": "제 5조(서비스의중단)",
    "article5_content": "회사는다음 각 호의 어느 하나에 해당하는 경우 서비스 의 전부 또는 일부를 중단할 수 있습니다.가.정기또는 비정기적인서버 점검 시 나.천재지변,전쟁,테러,운영상 의중대한 사고 등 불가항력적인 사유가 발생한 경우",
    "points_exchange_notice": "종이접기 제품을 모은 포인트로 교환할 수 있어요.",
    "all_categories": "전체",
    "points_highest": "포인트 높은 순",
    "points_lowest": "포인트 낮은 순",
    "points_sort_title": "정렬",
    "login_info_error": "로그인 정보를 가져올 수 없습니다.",
    "contact_support": "고객센터에 문의해주세요.",
    "register_again_confirm": "새로 등록하시겠습니까?",
    "account_unavailable": "귀하의 계정을 사용할 수 없습니다",
    "login_with_naver": "네이버로 로그인하기",
    "login_with_kakao": "카카오로 로그인하기",
    "login_with_google": "Google로 로그인하기",
    "login_with_apple": "Apple로 로그인하기",
    "post_updated": "게시물을 업데이트했어요.",
    "max_media_count": "최대 10장까지 업로드할 수 있습니다.",
    "file_too_large": "이미지는 최대 10MB까지 업로드할 수 있습니다.",
    "caption_required": "내용 입력해 주세요.",
    "tags_required": "최소 1개의 태그를 입력해주세요.",
    "media_required": "이미지 또는 동영상을 추가해주세요.",
    "tag_max_length_error": "태그는 50자 이하로 입력해주세요.",
    "changes_lost": "변경된 사항이 모두 사라집니다.<br />수정하기 페이지를 나가겠습니까?",
    "select_group": "그룹 선택",
    "video_url_input": "동영상 URL 입력",
    "sort": "정렬",
    "select_photos_videos": "갤러리에서 사진/영상 선택",
    "register_video_by_url": "URL로 동영상 등록",
    "attach": "첨부",
    "board_selection": "게시판 선택",
    "type": "유형",
    "image_type": "이미지",
    "video_url_type": "동영상 URL",
    "default_group": "기본",
    "product_name_placeholder": "상품명을 입력하세요.",
    "content_placeholder": "내용을 입력하세요.",
    "tag_input": "태그 입력",
    "tag_placeholder": "태그를 입력해주세요.",
    "tag_input_button": "입력",
    "max_tags_error": "태그는 최대 {count}개까지 입력할 수 있습니다.",
    "price_input": "가격 입력",
    "price_placeholder": "금액을 입력해주세요.",
    "url_label": "URL",
    "url_placeholder": "URL입력 (https://youtube.com)",
    "url_check_button": "확인",
    "url_error_message": "링크주소가 올바르지 않습니다.",
    "youtube_support_info": "현재 Youtube 영상만 지원합니다.",
    "youtube_share_instruction": "유튜브에서 공유 버튼을 눌러 제공되는 URL을 입력해 주세요.",
    "url_preview_instruction": "확인 버튼을 선택하여 노출되는 미리보기가 정상적인지 확인해주세요.",
    "challenge_available": "참여가능한 챌린지가",
    "challenge_count_unit": "개",
    "challenge_available_suffix": "있어요!",
    "bonus_points_earned_title": "{points} 포인트가 적립되었습니다.",
    "points_of_user": "님의 포인트",
    "unknown_user": "UNKNOWN",
    "user_default_name": "사용자",
    "no_blocked_users": "차단한 사용자가 없어요.",
    "blocked_at": "차단일",
    "unblock": "차단 해제",
    "unblock_confirm": "차단을 해제할까요?",
    "unblock_confirm_description": "{nickname} 님의 차단을 해제합니다.",
    "unblock_success": "차단을 해제했습니다.",
    "unblock_error": "차단 해제에 실패했습니다.",
    "blocked_user_unknown_nickname": "알 수 없는 사용자",
    "blocked_users_management": "차단 목록",
    "view_store_products": "무엇을 받을 수 있나 보기",
    "retry": "다시 시도",
    "write_first_post": "첫 글 쓰기",
    "clear_filter": "조건 지우기",
    "no_products_for_filter": "'{condition}' 조건에 맞는 상품이 없어요.",
    "failed_to_load_list": "목록을 불러오지 못했어요.",
    "browse_store": "스토어 둘러보기",
    "privacy_management": "차단 관리",
    "message_send_failed": "메시지 전송에 실패했습니다.",
    "image_send_failed": "이미지 전송에 실패했습니다.",
    "no_messages": "메시지가 없습니다",
    "message_media_alt": "Message media",
    "image_upload_limit": "최대 10개까지만 업로드가 가능합니다.",
    "message_input_placeholder": "메시지 보내기...",
    "blocked_user_message": "차단된 사용자와는 메시지를 보낼 수 없습니다",
    "message_send_error": "메시지 전송에 실패했습니다.",
    "post_author": "작성자",
    "challenges_all": "전체",
    "challenges_participable": "참여할 수 있는",
    "challenges_participated": "이미 참여한",
    "select_inquiry_period": "조회기간 선택",
    "read_more": "... 더보기",
    "show_less": "접기",
    "order_number": "주문번호",
    "order_date": "주문일자",
    "point_exchange_product": "포인트 교환 상품",
    "quantity": "수량",
    "tracking_code": "운송장 번호",
    "no_tracking_code": "추적 코드가 없습니다",
    "tracking_code_preparing": "운송장 번호 준비 중",
    "order_cancelled": "주문 취소",
    "total_payment": "총 결제금액",
    "total_exchange_points": "총 교환포이트",
    "rating": "별점 남기기",
    "select_rating": "별점을 선택해주세요.",
    "product_info_missing": "상품 정보가 없습니다.",
    "rating_saved": "별점이 저장되었습니다.",
    "rating_save_failed": "별점 저장에 실패했습니다.",
    "loading_rating_info": "평가 정보 로딩 중...",
    "saving": "저장 중...",
    "shipping_address": "배송지 정보",
    "insufficient_points": "포인트가 부족해요",
    "insufficient_points_message": "포인트가 부족하다면,",
    "participate_challenge": "포인트를 주는 챌린지에 참여",
    "participate_challenge_suffix": "해보세요!",
    "exchange_button": "교환하기",
    "insufficient_points_exchange": "귀하의 포인트가 이 상품을 교환하기에 충분하지 않습니다.",
    "exchange_address_submit_failed": "경품 받을 주소지 제출에 실패하였습니다.",
    "exchange_address_submit_failed_message": "다시시도하시거나, 문제가반복되는 경우<br />고객센터에 문의해 주세요.",
    "exchange_return_policy": "고객님이 원하실 경우, 구매하신 상품을 포인트로 반환해드립니다. 다만 아래의 경우 반환이 불가능합니다.",
    "exchange_policy_1": "상품 수령 후 7일이 경과한 경우",
    "exchange_policy_2": "수령한 상품을 개봉하여 재판매가 불가능한 경우",
    "exchange_product": "교환 상품",
    "personal_info_collection_consent": "상품 수령을 위한 개인정보 수집 이용 동의",
    "field_required_template": "$항목명$을/를 입력해 주세요.",
    "address_detail": "상세 주소",
    "prize_receipt_not_possible": "경품 수령이 불가합니다.",
    "personal_data_not_agreed": "개인정보수집 및 이용 동의를 하지 않는 경우,<br />경품발송이 불가합니다.",
    "exchange_complete": "교환 완료!",
    "exchange_success_message": "감사합니다! <br />고객님의 선물이 준비 중이며 곧 발송될 예정입니다.<br />주문 정보를 계속 확인해 주세요.",
    "enter_shipping_address": "배송지 입력",
    "agree_personal_info_collection": "위와 같이 개인정보를 수집·이용하는 데 동의하십니까?",
    "change_shipping_address": "배송지 변경",
    "add_shipping_address": "배송지 추가 +",
    "submit": "제출",
    "privacy_info_title": "개인정보 수집 및 이용 내역",
    "collection_purpose_text": "이벤트 당첨 경품 지급 및 배송",
    "retention_period_text": "경품 지급 완료 후 최대 3개월",
    "personal_info_items": "개인정보 수집 항목",
    "personal_info_items_text": "이름, 휴대폰 번호, 수령지 주소",
    "company_process_text": "당사는 이벤트 진행 및 경품 지급을 위하여 아래와 같이 업무를 처리합니다.",
    "contractor": "수탁사",
    "contractor_names": "한진택배",
    "purpose": "목적",
    "purpose_text": "경품 발송",
    "refusal_notice": "위의 개인정보 수집 이용에 대한 동의를 거부할 권리가 있습니다. 그러나, 동의를 거부할 경우 이벤트 진행 및 서비스 제공 대상에서 제외됨을 알려드립니다.",
    "product_receipt_notice": "상품 수령 안내",
    "receipt_within_two_weeks": "경품은 배송지 입력 후 2주 이내 수령 가능합니다.",
    "wrong_address_responsibility": "배송지 오입력 등에 대한 과실은 당첨자 본인에게 있습니다.",
    "inquiry_about_prize": "경품 발송 관련 문의는",
    "to_use": "를 이용해주시기 바랍니다.",
    "exchange_success_completed": "상품 교환이 성공적으로 완료되었습니다",
    "received": "받음",
    "no_points_yet": "아직 포인트가 없습니다.",
    "exchange": "교환",
    "seller_info_not_found": "판매자 정보를 찾을 수 없습니다.",
    "dm_button": "DM",
    "user_channel": "님의 채널",
    "send_dm": "DM 보내기",
    "follow_button": "팔로우하기",
    "group": "그룹",
    "user_deleted_msg": "사용자가 삭제되었습니다.",
    "user_suspended_msg": "사용자가 일시중지되었습니다.",
    "user_payment_cancelled_msg": "사용자가 결제를 취소하였습니다.",
    "points_deduction_confirmation": "{points} 포인트 차감합니다",
    "insufficient_points_title": "포인트 부족",
    "insufficient_points_message_2": "현재 포인트가 부족합니다.\n더 많은 활동을 통해 포인트를 적립하세요!",
    "terms_of_service": "서비스 이용약관 동의",
    "privacy_policy": "개인 정보 수집 및 이용 동의",
    "agree_all_terms": "모두 동의",
    "you_can_use_service_even_without_optional_agreement": "선택 항목에 대한 동의를 거부하시는 경우에도 서비스는 이용이 가능합니다.",
    "terms_of_service_agreement": "서비스 이용약관 동의 (필수)",
    "privacy_policy_agreement": "개인 정보 수집 및 이용 동의 (필수)",
    "age_confirmation": "만 14세 이상입니다.",
    "check_terms_of_service": "이용약관을 확인해 주세요.",
    "setup_email_title": "이메일을 설정해 주세요.",
    "email_label": "이메일",
    "email_address_placeholder": "이메일 주소를 입력해 주세요.",
    "setup_phone_title": "휴대폰번호를 입력해 주세요.",
    "phone_number_label": "휴대폰번호",
    "phone_number_input_placeholder": "휴대폰번호를 입력해주세요.",
    "invalid_phone_number_error": "올바른 휴대폰 번호를 입력해주세요.",
    "optional_notice": "해당 내용은 필수가 아닌 선택사항입니다.",
    "setup_referrer_title": "추천 회원을 입력해 주세요.",
    "nickname_label": "닉네임",
    "referrer_nickname_placeholder": "추천 회원의 닉네임을 입력해 주세요.",
    "nickname_does_not_exist_error": "존재하지 않는 닉네임 입니다.",
    "referrer_optional_notice": "해당 내용은 필수가 아닌 선택사항으로, 최초 가입 시 {referralPoints}포인트가 지급됩니다.",
    "setup_personal_info_title": "개인 정보를 입력해 주세요.",
    "age_label": "나이",
    "age_input_placeholder": "나이를 숫자로 입력해 주세요.",
    "birthdate_label": "생년월일",
    "select_birthdate": "생년월일을 선택해 주세요.",
    "birthdate_placeholder": "생년월일을 입력해 주세요.",
    "origami_experience_label": "종이접기 경력",
    "personal_info_optional_notice": "해당 내용은 필수가 아닌 선택사항으로, 최초 가입 시 {updateProfilePoints}포인트가 지급됩니다.",
    "setup_profile_title": "프로필을 설정해 주세요.",
    "image_upload_help_text": "1200x810px 사이즈의 이미지를 업로드해 주세요.",
    "sold_out": "품절",
    "cart_added_success": "장바구니에 상품이 담겼습니다.",
    "continue_shopping": "쇼핑 계속하기",
    "go_to_cart": "장바구니 이동",
    "un_authentication_message": "로그인이 필요한 기능입니다.<br /><br />로그인 화면으로 이동하시겠어요?",
    "total_amount_per_item": "총 금액",
    "order_product_total": "주문 상품",
    "membership_discount_with_percent": "멤버십 할인 {percent}%",
    "select_option": "상품을 선택해주세요.",
    "add_to_cart": "장바구니 담기",
    "buy_now": "바로 구매하기",
    "cart_title": "장바구니",
    "cart_empty": "장바구니가 비어있습니다.",
    "order_confirmation_title": "주문 확인",
    "buy_all_items_confirm": "장바구니에 담긴 {count}개의 상품을 모두 구매하시겠습니까?",
    "select_all_with_count": "전체 ({count})",
    "delete_all": "전부 삭제",
    "delete_selected_item_confirm": "선택하신 상품을 삭제하시겠습니까?",
    "delete_selected": "선택 삭제",
    "total_product_amount": "총 상품 금액",
    "total_shipping_fee": "총 배송비",
    "estimated_payment_amount": "결제 예정 금액",
    "buy_all_products": "전체 상품 구매",
    "buy_selected_products": "선택 상품 구매",
    "follow_success": "팔로우 되었습니다.",
    "unfollow_success": "언팔로우 되었습니다.",
    "point_earned_like": "콘텐츠 좋아요로 포인트가 적립되었습니다.",
    "point_earned_comment": "댓글 작성으로 포인트가 적립되었습니다.",
    "onboarding_board_description": "친구들이 올린 종이접기 작품과\n전문가들의 팁을\n한곳에서 볼 수 있어요.",
    "onboarding_joker_market_description": "내가 만든 종이접기를 자랑하고,\n원하는 가격으로 판매할 수 있어요.",
    "onboarding_newsletter_description": "조이쌤의 소식과 종이접기 전문 정보를\n빠르게 받아볼 수 있어요.",
    "onboarding_follow_description": "마음 맞는 친구를 팔로우 하고,\n서로의 종이접기 소식을\n나눌 수 있어요.",
    "onboarding_store_description": "다양한 종이접기 용품을\n쉽고 편하게 구매할 수 있어요.",
    "onboarding_skip": "건너뛰기",
    "onboarding_get_started": "시작하기",
    "login_token_expired": "로그인 토큰이 만료되었습니다. 다시 로그인해 주세요.",
    "server_response_unavailable": "서버 응답을 받을 수 없습니다. 다시 시도해 주세요.",
    "server_response_data_missing": "서버 응답에 필요한 데이터가 없습니다.",
    "profile_nickname_placeholder": "닉네임을 지어 주세요!",
    "required_badge": "(필수)",
    "not_logged_in_title": "로그인되어 있지 않습니다.",
    "go_to_login_confirm": "로그인 페이지로 이동하시겠습니까?",
    "joker_event_section_title": "조커 이벤트",
    "myroom_banner_aria_label": "종이접기 방 꾸미기 — 마이룸 가기",
    "myroom_banner_alt": "종이접기 방 꾸미기 - 3D공간에 나만의 종이접기를 전시해보세요.",
    "myroom_card_accent": "마이룸",
    "myroom_card_title_linked": "나만의 3D 공간",
    "myroom_card_title_new": "종이접기 방 꾸미기",
    "myroom_card_title_onboarding": "가입이 안 끝났어요",
    "myroom_card_subtitle": "3D공간에 나만의 종이접기를 전시해보세요.",
    "myroom_card_cta_linked": "마이룸 가기",
    "myroom_card_cta_new": "마이룸 꾸미러 가기",
    "myroom_card_cta_onboarding": "마이룸 이어서 가입하기",
    "myroom_card_item_badge": "완성된 3D 아이템이 있어",
    "myroom_card_item_done_title": "3D 아이템 제작 완료",
    "myroom_card_item_done_message": "{name} 제작이 완료되었습니다.\n아이템을 배치할까요?",
    "myroom_card_item_later": "나중에",
    "myroom_card_item_place": "배치하기",
    "myroom_cash_title": "포인트를 마이룸 캐시로 전환하기",
    "myroom_cash_sub_min": "{min}P부터 전환할 수 있어요",
    "myroom_cash_sub_balance": "보유 {points}P → 지금 바꾸면 {cash}C",
    "store_cat_best": "베스트",
    "store_cat_origami_books": "종이접기책",
    "store_cat_colored_paper": "색종이",
    "store_cat_other_tools": "기타 도구",
    "store_cat_sets": "세트상품",
    "pending_deposit_one": "입금을 기다리는 주문이 있어요",
    "pending_deposit_many": "입금을 기다리는 주문이 {count}건 있어요",
    "see_account": "계좌 보기",
    "myroom_misc_update_title": "앱 업데이트가 필요합니다",
    "myroom_misc_update_message": "마이룸은 최신 버전 앱에서 이용할 수 있습니다.\nApp Store에서 조이쌤 커넥트를 업데이트해주세요.",
    "myroom_frame_err_invalid_assertion": "연결 정보가 올바르지 않아요.\n다시 시도해 주세요.",
    "myroom_frame_err_expired_assertion": "연결 정보가 만료됐어요.\n다시 시도해 주세요.",
    "myroom_frame_err_network": "연결이 불안정해요.\n잠시 후 다시 시도해 주세요.",
    "myroom_frame_err_server": "마이룸에 일시적인 문제가 있어요.\n잠시 후 다시 시도해 주세요.",
    "myroom_frame_err_unknown": "잠시 후 다시 시도해 주세요.",
    "myroom_frame_rejected_withdrawn_title": "마이룸을 탈퇴한 계정이에요",
    "myroom_frame_rejected_withdrawn_body": "탈퇴한 뒤 14일 동안은 다시 연결할 수 없어요.",
    "myroom_frame_rejected_fallback_title": "마이룸에 연결할 수 없어요",
    "myroom_frame_rejected_fallback_body": "지금은 연결이 어려운 계정이에요.\n고객센터로 문의해 주세요.",
    "myroom_frame_date_fmt": "{m}월 {d}일",
    "myroom_frame_can_reconnect": "{date}부터 다시 연결할 수 있어요.",
    "myroom_frame_can_reconnect_days": "{date}({days}일 뒤)부터 다시 연결할 수 있어요.",
    "myroom_frame_sample_info_failed": "샘플 방 정보를 불러오지 못했습니다.",
    "myroom_frame_sample_load_failed": "샘플 방을 불러올 수 없습니다.",
    "myroom_frame_enter_info_failed": "방 진입 정보를 불러오지 못했습니다.",
    "myroom_frame_enter_failed": "방에 진입할 수 없습니다.",
    "myroom_frame_connecting": "마이룸에 연결 중이에요…",
    "myroom_frame_session_failed": "세션 교환에 실패했습니다.",
    "myroom_frame_session_error": "세션 교환 중 오류가 발생했습니다.",
    "myroom_frame_connected": "마이룸에 연결됐어요",
    "myroom_frame_link_done": "마이룸 연결이 완료됐어요",
    "myroom_frame_already_linked": "이미 연결돼 있어요",
    "myroom_frame_link_expired": "연결 시간이 지났어요. 다시 시도해 주세요",
    "myroom_frame_connect_failed_retry": "마이룸 연결에 실패했습니다. 잠시 후 다시 시도해 주세요.",
    "myroom_frame_connect_failed": "마이룸 연결에 실패했습니다.",
    "myroom_frame_consent_title": "마이룸 연동",
    "myroom_frame_consent_existing_1": "이미 만들어 둔 마이룸 계정이 있어요.",
    "myroom_frame_consent_existing_2": "계속하면 그 계정에 조이쌤 계정이 연결되고, 내 방으로 들어갑니다.",
    "myroom_frame_consent_new_1": "조이쌤 계정으로 마이룸을 시작합니다.",
    "myroom_frame_consent_new_2": "계속하면 조이쌤 계정과 마이룸이 연결돼요.",
    "myroom_frame_consenting": "연결 중…",
    "myroom_frame_agree_existing": "동의하고 내 방으로",
    "myroom_frame_agree_new": "동의하고 시작하기",
    "myroom_frame_back": "돌아가기",
    "myroom_frame_back_aria": "조이쌤으로 돌아가기",
    "myroom_frame_friend": "친구",
    "myroom_frame_friend_not_started": "{name}님은\n아직 마이룸을 시작하지 않았어요",
    "myroom_frame_title_link_needed": "마이룸 연결이 필요해요",
    "myroom_frame_title_login_needed": "로그인이 필요해요",
    "myroom_frame_title_cannot_open": "방을 열 수 없어요",
    "myroom_frame_desc_unavailable": "친구가 마이룸을 시작하면 방을 구경할 수 있어요.",
    "myroom_frame_desc_login": "다시 로그인한 뒤 마이룸에 들어와 주세요.",
    "myroom_frame_desc_link_required": "마이룸은 구글·카카오·애플·라인 계정으로 시작해요.\n네이버로 가입하셨다면 그중 하나를 골라 주세요.\n조이쌤 계정과 지금까지의 활동은 그대로예요.\n\n브라우저에서 로그인을 마치면 바로 돌아옵니다.",
    "myroom_frame_desc_social_required": "마이룸은 구글·카카오·애플·라인 계정으로 연결돼요.\n그중 하나로 로그인하면\n마이룸을 이용할 수 있어요.",
    "myroom_frame_btn_finish_signup": "마이룸 가입 마치기",
    "myroom_frame_btn_my_room": "내 방으로 가기",
    "myroom_frame_btn_link": "마이룸 연결하기",
    "myroom_frame_btn_social_login": "소셜 계정으로 로그인",
    "myroom_frame_btn_login": "로그인",
    "myroom_frame_btn_retry": "다시 시도",
    "myroom_frame_browser_hint": "브라우저가 열리지 않았나요?\n주소를 복사해 크롬이나 삼성 인터넷에 붙여 넣어 주세요.\nPC 에서 조이쌤에 로그인해 연결할 수도 있어요.",
    "myroom_frame_copied": "복사했어요",
    "myroom_frame_copy_link": "연결 주소 복사",
    "myroom_frame_loading_room": "방을 불러오는 중이에요…",
    "bottom_nav_modal_confirm": "확인",
    "expert_channel_section_title": "조이쌤과 함께하는 전문가 채널",
    "expert_channel_empty_message": "아직 등록된 전문가가 없습니다. <br />열심히 활동해서 첫 번째 전문가가 되어 보세요.",
    "content_slider_exam_title": "진행중인 자격 시험",
    "content_slider_exam_content": "2024년 대한민국 「어린이 종이접기 3급」 자격 시험 을 위한 학습을 원해 주세요...",
    "popular_posts_section_title": "와글와글 커뮤니티 게시글",
    "popular_posts_empty_message": "최근 12시간 내 작성된 인기글이 없습니다.",
    "certificate_application": "자격증 신청",
    "payment_complete_status": "결제완료",
    "product_prep_status": "상품준비중",
    "shipping_start_status": "배송시작",
    "vbank_share_title": "[조이쌤 커넥트] 입금 안내",
    "depositor": "예금주",
    "deposit_amount": "입금금액",
    "deposit_deadline": "입금기한",
    "until": "까지",
    "smart_delivery_tracking": "스마트택배 배송조회",
    "order_cancel_confirm_title": "주문을 취소하시겠습니까?",
    "order_cancel_confirm_message": "주문 취소 시, 환불은 카드사에 따라<br />영업일 기준 3~5일 정도 소요됩니다.",
    "order_cancel_done_title": "주문이 취소되었습니다",
    "order_cancel_done_message": "결제하신 금액은 환불 요청되었습니다.<br />환불은 카드사에 따라 영업일 기준 3~5일 정도 소요됩니다.",
    "payment_form_load_error": "결제창을 불러오지 못했습니다. 다시 시도해주세요.",
    "payment_form_submit_title": "결제양식 제출",
    "nickname_fallback_default": "쿠쿠루삥뽕리더쿠쿠루삥뽕리더",
    "order_cancel": "주문 취소",
    "save_complete_title": "저장 완료되었습니다",
    "withdrawal_error": "회원탈퇴 중 오류가 발생했습니다.",
    "congrats_bonus_points_title": "축하합니다!<br>{points} 포인트가 적립되었습니!(오타 원문 보존)",
    "marketing_consent_notice": "{year}년 {month}월 {day}일에 조이쌤에서 제공하는 마케팅 정보 수신에 {consent}.",
    "marketing_consent_agreed": "동의하였습니다",
    "marketing_consent_disagreed": "동의하지 않았습니다",
    "submit_work_step_photo_registration": "작품 사진 등록",
    "login_required_confirm_message": "로그인이 아닙니다. 계속하려면 로그인하세요<br/>로그인 화면으로 이동하시겠습니까?",
    "temp_save_success": "임시저장했어요.",
    "unsupported_image_format": "지원하지 않는 이미지 형식입니다",
    "field_title_ko": "작품명(한글)",
    "field_title_en": "작품명(영문)",
    "field_width": "가로",
    "field_height": "세로",
    "field_length": "높이",
    "field_description": "작품 설명",
    "field_work_type": "작품 형태(모양)",
    "field_number_of_paper": "사용 종이 매수(매)",
    "field_used_paper_shapes": "사용한 종이 모양",
    "field_has_cut_marks": "칼집",
    "field_is_glued": "풀칠",
    "field_finished_shape": "완성형 상태",
    "field_primary_folding_method": "기본형",
    "field_target_age": "대상연령(난이도)",
    "field_submitter_name_ko": "이름(한글)",
    "field_submitter_name_en": "이름(영문)",
    "field_birthdate": "생년월일",
    "field_country": "국가",
    "field_address1": "주소",
    "field_address2": "상세 주소",
    "field_mobile": "휴대폰번호",
    "field_phone": "전화번호",
    "field_email": "이메일",
    "field_social_media_url": "SNS 주소",
    "field_gender": "성별",
    "field_is_creator": "제작자 본인입니다",
    "field_co_maker": "공동 제작 여부",
    "field_required_suffix": "항목을 입력해 주세요.",
    "submit_button": "제출하기",
    "submit_work_title": "작품 제출",
    "temp_save": "임시저장",
    "leave_without_saving_title": "변경사항을 저장하지 않고 이동할까요?",
    "leave_without_saving_description": "작성하신 내용은 임시저장됩니다.",
    "submit_photo_face": "정면",
    "submit_photo_back": "뒷면",
    "submit_photo_left": "좌 측면",
    "submit_photo_right": "우 측면",
    "unsupported_image_format_title": "{name} 이미지의 {file} 이(가) 지원하지 않는 이미지 형식입니다.",
    "max_5_photos_limit": "최대 5개의 사진/영상만 등록할 수 있어요.",
    "option_has": "있어요",
    "option_none": "없어요",
    "select_target_age_title": "대상연령(난이도) 선택",
    "select_completed_state_title": "완성형 상태 선택",
    "select_basic_type_title": "기본형 선택",
    "select_paper_shape_title": "사용한 종이모양 선택",
    "placeholder_input_korean": "한글로 입력해 주세요.",
    "placeholder_input_english": "영문으로 입력해 주세요.",
    "field_work_dimension": "작품규격(cm)",
    "dimension_range_error": "0.01 ~ 10000 사이 숫자를 입력해 주세요.",
    "placeholder_work_shape_description": "동물/공룡/식물/탈것/캐릭터/건물/유적/도형/기호/문자/벌레/물고기 등으로 모양을 설명해 주세요.",
    "placeholder_input_paper_count": "사용 종이 매수를 입력해 주세요.",
    "placeholder_select_paper_shape": "종이 모양을 선택해 주세요.",
    "placeholder_input_finished_shape": "완성형 상태를 입력해 주세요.",
    "placeholder_input_basic_type": "기본형을 입력해 주세요.",
    "placeholder_input_target_age": "대상연령(난이도)를 입력해 주세요.",
    "placeholder_numbers_only": "숫자만 입력해 주세요.",
    "placeholder_input_mobile": "휴대폰번호를 입력해주세요.",
    "placeholder_input_email": "이메일을 입력해 주세요.",
    "placeholder_input_sns_url": "SNS 주소를 입력해 주세요.",
    "gender_male": "남자",
    "gender_female": "여자",
    "checkbox_is_creator": "제작자 본인입니다.",
    "required_marker": "(필수)",
    "submitter_legal_responsibility_notice": "본인이 아닌 경우, 법적 책임은 제출자 본인에게 있으며 당선이 취소될 수 있습니다.",
    "privacy_consent_notice_html": "<p style=\"font-weight: 700; font-size: 12px; margin-top: 0; margin-bottom: 20px\">공모전에 참여하는 경우 추가적인 개인정보를 수집합니다.</p><p style=\"font-weight: 400; font-size: 12px; margin-top: 0; margin-bottom: 20px\">조이씽은 개인정보 보호법 제 30조에 따라 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용목적이 변경되는 경우에는 개인정보 보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.</p><div><span>개인정보 수집 및 이용 내역</span><ul><li>수집 및 이용 목적: 공모전 참가를 위한 참가자의 개인 식별</li><li>보유기간:참가일로부터 5년 보관(전자상거래 등에서의 소비자보호에 관한 법률)<br/>단,관련 법령 및 회사 정책에 따라 별도 보관되는 정보는 예외</li><li>개인정보 수집 항목: 이름, 휴대폰 번호, 수령지 주소</li></ul></div><div><span>개인정보 수집 항목</span><ul><li>필수: 이름(한글), 이름(영문) , 생년월일, 휴대폰 번호, 주소</li><li>선택: 성별, 전화번호, 이메일, SNS 주소, 공동 제작자 정보</li></ul></div><span>위의 개인정보의 수집 이용에 대한 동의를 거부할 권리가 있습니다. 그러나, 동의를 거부할 경우 이 이벤트 관련 서비스 제공에 제한을 받을 수 있습니다.</span>",
    "privacy_consent_confirm_question": "위와 같이 개인정보를 수집·이용하는 데 동의하십니까?",
    "select_country_title": "국가 선택",
    "co_maker_alone": "혼자했어요",
    "co_maker_together": "같이했어요",
    "field_co_maker_name_ko": "공동 제작자 이름(한글)",
    "placeholder_co_maker_name": "이름(소속) 형태로 작성해 주세요.여러 명인 경우 , 로 구분해 주세요",
    "seconds_unit": "초",
    "free_trial_coming_soon_title": "무료체험 서비스를 준비 중입니다.",
    "qualification_test_coming_soon_title": "자격시험 서비스를 준비 중입니다.",
    "my_points_amount_line": "내 포인트 {amount}P",
    "points_remaining_line": "{lowest}P까지 {remain}P 남음",
    "no_news_registered": "등록된 소식이 없습니다",
    "shipping_modal_default_description": "종이 나라 과학 나라",
} as const;

export type KoTranslationKeys = keyof typeof koTranslations;
